<div (mouseenter)="navOpen = true;" (mouseleave)="navOpen = false;" class="collage-nav"
     [ngClass]="{'collage-nav-closed': !navOpen, 'collage-nav-open': navOpen}" data-cy="collage-nav-container">
  <div *ngIf="navOpen" style="display: flex; flex-direction: column; flex: 1; padding: 10px;" data-cy="collage-nav-content">
    <div style="display: flex;" data-cy="collage-nav-filter-section">
      <div style="flex: 1; height: 80px; background-color: white; border-radius: var(--border-radius); border: 1px solid rgba(0,0,0,0.05);" data-cy="collage-nav-filter-display">
        <div style="display: flex;" data-cy="collage-nav-date-row">
          <span style="font-weight: 500; flex-basis: 50px; text-align: right;" data-cy="collage-nav-date-label">Date:</span>
          <span style="color: var(--tdo-primary); flex: 1; margin-left: 8px;" data-cy="collage-nav-date-value">{{filterModel?.startDate.toLocaleDateString()}} - {{filterModel?.endDate.toLocaleDateString()}}</span>
        </div>
        <div style="display: flex;" data-cy="collage-nav-fetch-row">
          <span style="font-weight: 500; flex-basis: 50px; text-align: right;" data-cy="collage-nav-fetch-label">Fetch:</span>
          <span style="color: var(--tdo-primary); flex: 1; margin-left: 8px;" data-cy="collage-nav-fetch-value">{{getFetchLabel()}}</span>
        </div>
        <div style="display: flex;" data-cy="collage-nav-sort-row">
          <span style="font-weight: 500; flex-basis: 50px; text-align: right;" data-cy="collage-nav-sort-label">Sort:</span>
          <span style="color: var(--tdo-primary); flex: 1; margin-left: 8px;" data-cy="collage-nav-sort-value">{{filterModel?.sortType}}</span>
        </div>
      </div>
      <div (click)="onOpenFilterDialog()" style="flex-basis: fit-content; cursor: pointer; color: var(--tdo-secondary);" data-cy="collage-nav-filter-button">
        <mat-icon style="margin-left: 4px;" matTooltip="Filter" data-cy="collage-nav-filter-icon">filter_alt</mat-icon>
      </div>
    </div>
    <div style="margin-top: 10px;" data-cy="collage-nav-previous-header">
      <mat-label style="text-align: center" data-cy="collage-nav-previous-label">Previous Collages:</mat-label>
    </div>
    <div style="flex: 1; background-color: rgba(0,0,0,0.02); overflow-y: auto;" data-cy="collage-nav-collages-list">
      <div style="height: 2000px;" data-cy="collage-nav-list-content">
        TEST
      </div>
    </div>
  </div>
  <div style="flex-basis: fit-content; cursor: pointer; background-color: rgba(0,0,0,0.1);" (click)="navOpen = !navOpen" data-cy="collage-nav-toggle">
    <div style="height: 100%; position: relative;" data-cy="collage-nav-toggle-container">
      <mat-icon style="position: relative; top: 50%; transform: translateY(-50%);" *ngIf="!navOpen" data-cy="collage-nav-open-icon">chevron_right
      </mat-icon>
      <mat-icon style="position: relative; top: 50%; transform: translateY(-50%);" *ngIf="navOpen" data-cy="collage-nav-close-icon">chevron_left
      </mat-icon>
    </div>
  </div>
</div>
